var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* eslint-disable comma-dangle, no-var, react/sort-comp */
/* TODO(csilvers): fix these lint errors (http://eslint.org/docs/rules): */
/* To fix, remove an entry above, run ka-lint, and fix errors. */

var React = require("react");
var _ = require("underscore");

var Changeable = require("../mixins/changeable.jsx");

var PerseusMarkdown = require("../perseus-markdown.jsx");
var mdParse = PerseusMarkdown.parse;
var mdOutput = PerseusMarkdown.basicOutput;

var SimpleMarkdownTester = React.createClass({
    displayName: "SimpleMarkdownTester",

    propTypes: _extends({}, Changeable.propTypes, {
        value: React.PropTypes.string
    }),

    getDefaultProps: function getDefaultProps() {
        return {
            value: ""
        };
    },

    change: function change() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return Changeable.change.apply(this, args);
    },


    toJSON: function toJSON() {
        return {};
    },

    render: function render() {
        var parsed = mdParse(this.props.value);
        var output = mdOutput(parsed);
        return React.createElement(
            "div",
            null,
            output
        );
    },

    /**
     * Widgets that are focusable should add a focus method that returns
     * true if focusing succeeded. The first such widget found will be
     * focused on page load.
     */
    focus: function focus() {
        this.refs.input.focus();
        return true;
    },

    /**
     * simpleValidate is called for grading. Rubric is the result of calling
     * toJSON() on the editor that created this widget.
     *
     * Should return an object representing the grading result, such as
     * {
     *     type: "points",
     *     earned: 1,
     *     total: 1,
     *     message: null
     * }
     */
    simpleValidate: function simpleValidate(rubric) {
        return SimpleMarkdownTester.validate(this.toJSON(), rubric);
    }
});

/**
 * This is the widget's grading function
 */
_.extend(SimpleMarkdownTester, {
    /**
     * simpleValidate generally defers to this function
     *
     * state is usually the result of toJSON on the widget
     * rubric is the result of calling toJSON() on the editor
     */
    validate: function validate(state, rubric) {
        return {
            type: "points",
            earned: 0,
            total: 0,
            message: null
        };
    }
});

/**
 * For this widget to work, we must require() this file in src/all-widgets.js
 */
module.exports = {
    name: "simple-markdown-tester",
    displayName: "Simple Markdown Tester",
    hidden: true, // Hides this widget from the Perseus.Editor widget select
    widget: SimpleMarkdownTester,
    transform: _.identity
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/widgets/simple-markdown-tester.jsx
 ** module id = 162
 ** module chunks = 0 1
 **/